"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const core_1 = require("@material-ui/core");
const styles_1 = __importDefault(require("./styles"));
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(utc_1.default);
// Make Clock as individual component so the timer won't make the expensive component re-render
const Clock = ({ elapsed }) => {
    const classes = styles_1.default();
    const [elapsedTime, setElapsedTime] = react_1.useState(elapsed || 0);
    react_1.useEffect(() => {
        const timer = setInterval(() => {
            setElapsedTime((seconds) => seconds + 1);
        }, 1000);
        return () => {
            clearInterval(timer);
        };
    });
    return (react_1.default.createElement(core_1.Typography, { className: classes.clock, variant: "body1" }, dayjs_1.default
        .utc(dayjs_1.default.duration({ seconds: elapsedTime }).asMilliseconds())
        .format('HH:mm:ss')));
};
exports.default = Clock;
